import { DepositTokenSymbol } from '../config/chains';

export function getNadoReceiveTokenSymbol(
  selectedTokenSymbol: DepositTokenSymbol | 'USDT' | string,
): Extract<DepositTokenSymbol, 'USDT0' | 'USDC'> {
  return selectedTokenSymbol === 'USDC' ? 'USDC' : 'USDT0';
}
